module.exports = __webpack_public_path__ + "img/clock-counter-clockwise.18c0c339.svg";